import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div style={{ textAlign: 'center', padding: '6rem 2rem' }}>
      <h1 style={{ fontFamily: 'Fraunces, serif', fontSize: '5rem', color: '#e2dbd0', marginBottom: '1rem' }}>404</h1>
      <p style={{ color: '#7a6f65', marginBottom: '2rem', fontSize: '1.1rem' }}>This page doesn't exist.</p>
      <Link to="/" style={{ background: '#c0392b', color: '#fff', padding: '0.75rem 2rem', borderRadius: 10, textDecoration: 'none', fontWeight: 600 }}>
        Go home →
      </Link>
    </div>
  );
}
